(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var sections = main.querySelectorAll(':scope > [id^="shopify-section-"]');
    if (!sections.length) return;

    // Skip the first two sections (hero + whatever sits directly under it, e.g.
    // a thin trust marquee) — show them immediately, no animation. Animating a
    // section right at the top of the page just delays it appearing on first
    // paint and reads as a layout gap while it's still translated/faded out.
    var skipCount = Math.min(2, sections.length);
    for (var i = 0; i < skipCount; i++) {
      sections[i].classList.add('diolysh-no-reveal');
    }

    if (!('IntersectionObserver' in window)) {
      for (var j = 0; j < sections.length; j++) {
        sections[j].classList.add('diolysh-revealed');
      }
      return;
    }

    // threshold 0 + a bottom rootMargin means the callback fires as soon as ANY
    // part of a section enters the viewport, rather than requiring a fixed
    // percentage of the section's own area to be visible. A percentage-based
    // threshold breaks for unusually tall sections (e.g. long product grids
    // many times the viewport height), which may never reach a 10% ratio.
    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('diolysh-revealed');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -10% 0px' }
    );

    for (var k = skipCount; k < sections.length; k++) {
      observer.observe(sections[k]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
